import Profiler from "../../../Measurement/Profiler";


const MeasurementWithMapContent = () => {
  return(
    <Profiler/>
  )
}
export default MeasurementWithMapContent